import { render, staticRenderFns } from "./PStep2.vue?vue&type=template&id=569cb9cc&scoped=true"
import script from "./PStep2.vue?vue&type=script&lang=js"
export * from "./PStep2.vue?vue&type=script&lang=js"
import style0 from "./PStep2.vue?vue&type=style&index=0&id=569cb9cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569cb9cc",
  null
  
)

export default component.exports